<!-- title="Doctors Next™" -->
<app-lock-login
  title=""
  pageTitle="テストアプリ"
  logo="https://cdn-cafje.nitrocdn.com/NwOfOSIKahyTFPgsCqGJEMpFItmdqQhY/assets/doctors-station/optimized/rev-63d13ce/wp-content/uploads/2020/10/WM-New-Logo-1-1.svg"
  clientId="6rlApu6lD0OGotWbtfbeF0Ix523YpZQx"
  domain="ag-doctors-dev.jp.auth0.com"
signUpTerm="Doctors IDの<a href='/assets/terms.html' target='_blank'>利用規約</a>と<a href='/assets/privacy.html' target='_blank'>プライバシーポリシー</a> に同意します。" 
></app-lock-login>
